import { Helmet } from "react-helmet";
import { useFormik } from "formik";
import {
    Box,
    InputAdornment,
    Typography,
    Button,
    Grid,
    TextField,
    FormHelperText
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState, useEffect } from "react";
import eye from '../../icons/eye-fill.svg';
import { useDispatch, useSelector } from "react-redux";
import * as yup from 'yup';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import authService from "../../services/auth.service";
import SimpleDialog from "../../components/SimpleDialog";
import MessageDialog from "../../components/inbox/MessageDialog";
// import React, { useState, useEffect } from "react";
// import { color, maxWidth } from "@material-ui/system";
const useStyles = makeStyles({
    mainSetLang: {
        boxShadow: "none"
    },
    inputLang: {
        width: "100%",
        "& fieldset": {
            borderColor: "#979797",
        },
        "& .MuiSelect-select": {
            padding: "10px 0 9px 15px",
            color: "#4A877D"
        },
        "& .MuiMenuItem-root, .MuiOutlinedInput-root": {
            width: "100%",
            fontSize: "14px",
            lineHeight: "21px"
        }
    },
});
const styles = {
    containerChangePassword: {
        padding: "22px 25px 100px 24px",
    },
    title: {
        paddingBottom: "21px",
        borderBottom: "1px solid #E7E8E7",
        fontWeight: "600"
    },
    boxForm: {
        paddingTop: "30px",
        position: "relative"
    },
    formBg: {
        background: "#FAFAFA",

    },
    iconEye: {
        position: "absolute",
        right: "20px",
        bottom: "28px",
        width: "18px",
        height: "18px"
    }
};

const ChangePassword = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const Start = useSelector((state) => state.Start);
    const [blurFirst, setBlurFirst] = useState(false);
    const [errorCurrentPassword, setErrorCurrentPassword] = useState(false);
    const [errorPassword, setErrorPassword] = useState(false);
    const [showPasswordOld, setShowPasswordOld] = useState(false);
    const [showPasswordNew, setShowPasswordNew] = useState(false);
    const [showPasswordConfrim, setShowPasswordConfrim] = useState(false);
    const handleClickShowPasswordOld = () => setShowPasswordOld(!showPasswordOld);
    const handleMouseDownPasswordOld = () => setShowPasswordOld(!showPasswordOld);
    const handleClickShowPasswordNew = () => setShowPasswordNew(!showPasswordNew);
    const handleMouseDownPasswordNew = () => setShowPasswordNew(!showPasswordNew);
    const handleClickShowPasswordConfrim = () => setShowPasswordConfrim(!showPasswordConfrim);
    const handleMouseDownPasswordConfrim = () => setShowPasswordConfrim(!showPasswordConfrim);
    const validationSchema = yup.object().shape(
        {
            passwordOld: yup.string()
                .required(t('profile.emtyVal')),
            passwordNew: yup.string()
                .required(t('profile.passwordMust'))
                .min(8, t('profile.passwordMust'))
                .matches(
                    /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z])(?=.*[!@#$%^&*()\-_+={`~[\]\\};':/"|,.<?>])[A-Za-z\d!@#$%^&*()\-_+={`~[\]\\};':/"|,.<?>]{8,}$/,
                    t('profile.passwordMust')),
            passwordConfrim: yup.string().required(t('profile.emtyVal')).when("passwordNew", {
                is: val => (val && val.length > 0 ? true : false),
                then: yup.string().oneOf(
                    [yup.ref("passwordNew")],
                    t('profile.notMatch')
                )
            })
        }
    )
    const formik = useFormik({
        initialValues: {
            passwordOld: "",
            passwordNew: "",
            passwordConfrim: "",
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log(values);
            sunMit(values)
        },
    });

    useEffect(() => {
        const myInput = document.getElementById('passwordConfrim');
        myInput.onpaste = e => e.preventDefault();
    }, []);
    useEffect(() => {
        if (errorCurrentPassword) {
            setErrorCurrentPassword(false)
        }
    }, [formik.values.passwordOld]);

    useEffect(() => {
        if (errorPassword) {
            setErrorPassword(false)
        }
    }, [formik.values.passwordNew]);
    const sunMit = (val) => {
        let dt = {
            user: "",
            username: "",
            pincode: "",
            password: val.passwordOld,
            new_password: val.passwordNew,
            options: {}
        }
        authService.changePassword(dt).then((rs) => {
            openSuccessAddDialog(true)
            formik.resetForm()
        }).catch((err) => {
            if (err?.data?.code === "req.msg.invalid_information") {
                setErrorCurrentPassword(true)
            } else if (err?.data?.code === "login.msg.chg_pwd_error") {
                setErrorPassword(true)
            }
        })

    }

    const handleSubmit = () => {
        formik.submitForm()
    }

    const onBlurForm = (e, type) => {
        formik.handleBlur(e)
        if (blurFirst === false && type === "new") {
            setBlurFirst(true)
        }
    }

    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const handleDirect = () => {
        openSuccessAddDialog(false)
    }

    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    return (
        <>
            <Box style={styles.containerChangePassword}>
                <Box>
                    <Typography fontSize={24} lineHeight="36px" color="#404349" style={styles.title}>{t('profile.changePassword')}</Typography>
                </Box>
                <Box>
                    <Grid
                        item
                        style={styles.boxForm}
                    >
                        <Typography fontSize={16} lineHeight="24px" color="#404349" pb="15px">{t('profile.currentPassword')}</Typography>
                        <Box sx={{ display: "flex", flexFlow: "row", alignItems: "center", ".MuiFormHelperText-root.Mui-error": { margin: " 1.5px 0 0 15px", fontSize: "14px", lineHeight: "21px", color: "#CC6058 !important", width: "calc(50% - 15px)" }, ".MuiOutlinedInput-root": { padding: "11px 0 11px 14px", height: "45px", ".MuiInputBase-input": { padding: "0" } } }}>
                            <TextField
                                fullWidth
                                // label="Password"
                                placeholder={t('profile.enterCurrentPassword')}
                                margin="normal"
                                name="passwordOld"
                                onBlur={e => onBlurForm(e)}
                                onChange={formik.handleChange}
                                type={showPasswordOld ? "text" : "password"}
                                value={formik.values.passwordOld}
                                variant="outlined"
                                required
                                sx={{ margin: "0", marginRight: "15px", width: "calc(50% - 15px)", ".MuiOutlinedInput-root": { color: "#404349", } }}
                                error={errorCurrentPassword ? errorCurrentPassword : Boolean(formik.touched.passwordOld && formik.errors.passwordOld)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPasswordOld}
                                                onMouseDown={handleMouseDownPasswordOld}
                                            >
                                                {showPasswordOld ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {errorCurrentPassword ? (<FormHelperText error sx={{ margin: " 1.5px 0 0 15px", fontSize: "14px", lineHeight: "21px", width: "calc(50% - 15px)" }}>{t('profile.currentPasswordsInvalid')}</FormHelperText>) :
                                formik.touched.passwordOld && formik.errors.passwordOld ? (<FormHelperText error sx={{ margin: " 1.5px 0 0 15px", fontSize: "14px", lineHeight: "21px", width: "calc(50% - 15px)" }}>{formik.errors.passwordOld} </FormHelperText>) : <></>}
                        </Box>
                    </Grid>
                    <Grid
                        item
                        style={styles.boxForm}
                    >
                        <Typography fontSize={16} lineHeight="24px" color="#404349" pb="15px">{t('profile.newPassword')}</Typography>
                        <Box sx={{ display: "flex", flexFlow: "row", alignItems: "center", ".MuiFormHelperText-root.Mui-error": { margin: " 1.5px 0 0 15px", fontSize: "14px", lineHeight: "21px", color: "#CC6058 !important", width: "calc(50% - 15px)" }, ".MuiOutlinedInput-root": { padding: "11px 0 11px 14px", height: "45px", ".MuiInputBase-input": { padding: "0" } } }}>
                            <TextField
                                fullWidth
                                // label="Password"
                                placeholder={t('profile.enterNewPassword')}
                                margin="normal"
                                name="passwordNew"
                                onBlur={e => onBlurForm(e, "new")}
                                onChange={formik.handleChange}
                                type={showPasswordNew ? "text" : "password"}
                                value={formik.values.passwordNew}
                                variant="outlined"
                                required
                                sx={{ margin: "0", marginRight: "15px", width: "calc(50% - 15px)", ".MuiOutlinedInput-root": { color: "#404349", } }}
                                // helperText={formik.touched.passwordNew && formik.errors.passwordNew}
                                error={errorPassword ? errorPassword : Boolean(formik.touched.passwordNew && formik.errors.passwordNew)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPasswordNew}
                                                onMouseDown={handleMouseDownPasswordNew}
                                            >
                                                {showPasswordNew ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {errorPassword ?
                                <FormHelperText error sx={{ margin: " 1.5px 0 0 15px", fontSize: "14px", lineHeight: "21px", width: "calc(50% - 15px)" }}>{t('profile.previousOldPassword')}</FormHelperText>
                                :
                                <FormHelperText sx={{ margin: " 1.5px 0 0 15px", fontSize: "14px", lineHeight: "21px", color: blurFirst === false ? "#AAAAAA" : Boolean(formik.touched.passwordNew && formik.errors.passwordNew) === true ? "#CC6058" : "#5DA196", width: "calc(50% - 15px)" }}>{t('profile.passwordMust')}</FormHelperText>
                            }
                        </Box>
                    </Grid>
                    <Grid
                        item
                        style={styles.boxForm}
                    >
                        <Typography fontSize={16} lineHeight="24px" color="#404349" pb="15px">{t('profile.confirmPassword')}</Typography>
                        <Box sx={{ display: "flex", flexFlow: "row", alignItems: "center", ".MuiFormHelperText-root.Mui-error": { margin: " 1.5px 0 0 15px", fontSize: "14px", lineHeight: "21px", color: "#CC6058 !important", width: "calc(50% - 15px)" }, ".MuiOutlinedInput-root": { padding: "11px 0 11px 14px", height: "45px", ".MuiInputBase-input": { padding: "0" } } }}>
                            <TextField
                                fullWidth
                                // label="Password"
                                id="passwordConfrim"
                                placeholder={t('profile.enterConfirmPassword')}
                                margin="normal"
                                name="passwordConfrim"
                                onBlur={e => onBlurForm(e)}
                                onChange={formik.handleChange}
                                type={showPasswordConfrim ? "text" : "password"}
                                value={formik.values.passwordConfrim}
                                variant="outlined"
                                required
                                sx={{ margin: "0", marginRight: "15px", width: "calc(50% - 15px)", ".MuiOutlinedInput-root": { color: "#404349", } }}
                                // helperText={formik.touched.passwordConfrim && formik.errors.passwordConfrim}
                                error={Boolean(formik.touched.passwordConfrim && formik.errors.passwordConfrim)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPasswordConfrim}
                                                onMouseDown={handleMouseDownPasswordConfrim}
                                            >
                                                {showPasswordConfrim ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {formik.touched.passwordConfrim && formik.errors.passwordConfrim ? (<FormHelperText error sx={{ margin: " 1.5px 0 0 15px", fontSize: "14px", lineHeight: "21px", width: "calc(50% - 15px)" }}>{formik.errors.passwordConfrim} </FormHelperText>) : <></>}
                        </Box>
                    </Grid>
                    <Box sx={{ py: 2, paddingTop: "44px" }}>
                        <Button
                            color="primary"
                            // disabled={isSubmitting}
                            size="large"
                            type="submit"
                            variant="contained"
                            onClick={handleSubmit}
                        >
                            <Typography sx={{ textTransform: "none" }} fontSize={16} lineHeight="26.91px" fontWeight="500" color="#FFF">
                                {t('label.save')}
                            </Typography>
                        </Button>
                    </Box>
                </Box>
            </Box >
            <SimpleDialog
                open={isSuccessAddDialogOpen}
                doDirect={() => handleDirect()}
                setValue={openSuccessAddDialog}
                text={t(`profile.success`)}
                page={true}
                subTitle=""
            />
            <MessageDialog
                open={openFailedMessageDialog}
                setValue={handleCloseFailedMessageDialog}
                type="fail"
                title={t(`dialog.label.fail`)}
                text={t(`profile.error`)}
            />
        </>
    );
};
export default ChangePassword;
